<template>
	<div id="app">
		<el-container>
			<el-header class="div-header">
				<Header />
				<el-divider class="header-divider"></el-divider>
			</el-header>

			<div class="main-div">
				<el-container class="main-div parentDiv">
					<splitpanes class="default-theme defaultStyle custom-splite">
						<pane size="100" class="SideBarLeft">
              <!--SID1038 Body Part -->
							<template>
								<el-container>
									<div class="SID1008__EmailDeliveryRegistration">
									<!-- Breadcrumb section -->
									<el-breadcrumb separator-class="el-icon-arrow-right">
										<el-breadcrumb-item :to="{ path: '0002' }">トップ(記事一覧)</el-breadcrumb-item>
										<el-breadcrumb-item :to="{ path: '1007' }">メール配信先一覧</el-breadcrumb-item>
										<el-breadcrumb-item :to="{ path: '' }">メール配信先登録</el-breadcrumb-item>
									</el-breadcrumb>
										<div class="registerDiv">
											<el-form ref="form" :rules="rules" :model="form" class="div-form" label-width="auto">
												<el-form-item label="媒体" prop="mediumvalue">

															<div v-if="this.$route.params.response">
															<span>{{ this.mediaNameSet }}</span>
															</div>
															<div v-else>
															<el-select v-model="form.mediumvalue" :disabled="mediumvaluedisable == 1" @change="mediaChange($event)" placeholder="">
															<el-option
															v-for="(item,index) in getDrop" 
															:key="index"
															:label="item.label"
															:value="item.value">
															</el-option>
														</el-select>
														</div>
															
													</el-form-item>
													<el-form-item label="テーマ" prop="getthemevalue">
														<span  class="themeAlertClass">{{ themeSpan }}</span>
														<!-- 2022/09/28 No16.メール配信先設定のテーマを変更できるようにしたい  START-->
														<!-- <el-select v-model="form.getthemevalue" :disabled="getthemevaluedisable == 1" @change="handleChange($event)" placeholder=""> -->
														<el-select v-model="form.getthemevalue" @change="handleChange($event)" placeholder="">
														<!-- 2022/09/28 No16.メール配信先設定のテーマを変更できるようにしたい  END-->
															<el-option
															v-for="(item,index) in getthemeoptions"
															:key="index"
															:label="item.value"
															:value="item.id">
															</el-option>
														</el-select>
													
													</el-form-item>  
													<el-form-item class="el-lbl-content" label="メールアドレス" prop="radio">
														<el-radio-group v-model="form.radio">
														<el-radio  label="1" id="chkYes" name="checkSelect" @change="changeradio($event)">登録済メールアドレスから選択</el-radio>
														<el-radio  label="2"  id="chkNo"  name="checkSelected" @change="changeradio($event)">メールアドレスを直接入力</el-radio>
														</el-radio-group>
														
													</el-form-item>
													<el-row class="el-select-row" >
														<el-form-item label="" prop="emailoptvalue" class="dflex">
															<span class="emailAlertCustom">{{ emailAlertSelect }}</span>
														<el-select v-model="form.emailoptvalue" :disabled="disable == 1" @change="mailChange($event)" placeholder="" >
															
															<el-option
															v-for="(item,index) in getemailoptions"
															:key="index"
															:label="item.mail_address"
															:value="item.mail_address"
															>
															</el-option>
														</el-select>
														
														<el-form-item prop="emailvalue">
														
															<span class="emailAlertClass">{{ emailAlert }}</span>
															<el-input v-model="form.emailvalue" :disabled="disabled == 1" class="inputEmail inputtrimdiv"
															></el-input>
															</el-form-item>
														</el-form-item>
													</el-row>
													
														<el-form-item label="テンプレートファイル" prop="templatevalue" v-if="mediaWeb_medium == 1">
															<span class="themeAlertClass">{{ templateSpan }}</span>
														<el-select v-model="form.templatevalue" :disabled="mediaWeb == 1" @change="templateFileChange($event)" placeholder="">
															<el-option
															v-for="(item,index) in getdropdown_mail"
															:key="index"
															:label="item.label"
															:value="item.value">
															</el-option>
														</el-select>
														<el-button  type="primary" @click="validationFields" :disabled="mediaWeb == 1" plain class="InputButtonDiv ButtonPreview" >プレビュー</el-button>
														</el-form-item>
														<el-form-item label="テンプレートファイル"  v-else>
															<span class="themeAlertClass">{{ templateSpan }}</span>
														<el-select v-model="form.templatevalue" :disabled="mediaWeb == 1" @change="templateFileChange($event)" placeholder="">
															<el-option
															v-for="(item,index) in getdropdown_mail"
															:key="index"
															:label="item.label"
															:value="item.value">
															</el-option>
														</el-select>
														<el-button  type="primary" @click="validationFields" :disabled="mediaWeb == 1" plain class="InputButtonDiv ButtonPreview" >プレビュー</el-button>
														</el-form-item>
														
													
													<el-form-item label="0件時にメール送信しない">
														<el-switch v-model="value4"  class="inputSwitch"></el-switch>
													</el-form-item>
													
													<el-form-item label="件名" prop="getsubjectvalue"  class="dflex" v-if="mediaWeb_medium == 1">
														<span class="emailAlertCustom">{{ subjectAlert }}</span>
														<el-select v-model="form.getsubjectvalue" :disabled="mediaWeb == 1" @change="subjectChange($event)" placeholder="">
															<el-option
															v-for="(item,index) in getsubjectoptions"
															:key="index"
															:label="item.label"
															:value="item.value">
															</el-option>
														</el-select>
													</el-form-item>
													<el-form-item label="件名"   class="dflex" v-else>
														<span class="emailAlertCustom">{{ subjectAlert }}</span>
														<el-select v-model="form.getsubjectvalue" :disabled="mediaWeb == 1" @change="subjectChange($event)" placeholder="">
															<el-option
															v-for="(item,index) in getsubjectoptions"
															:key="index"
															:label="item.label"
															:value="item.value">
															</el-option>
														</el-select>
													</el-form-item>

													<el-form-item label="添付形式" prop="getattachmentvalue"  class="dflex" v-if="mediaWeb_medium == 1">
														<span class="emailAlertCustom">{{ attachalert }}</span>
														<el-select v-model="form.getattachmentvalue" :disabled="mediaWeb == 1" @change="attachmentChange($event)" placeholder="">
															<el-option
															v-for="(item,index) in getattachmentoptions" 
															:key="index"
															:label="item.label"
															:value="item.value">
															</el-option>
														</el-select>
													</el-form-item>
													<el-form-item label="添付形式"   class="dflex" v-else>
														<span class="emailAlertCustom">{{ attachalert }}</span>
														<el-select v-model="form.getattachmentvalue" :disabled="mediaWeb == 1" @change="attachmentChange($event)" placeholder="">
															<el-option
															v-for="(item,index) in getattachmentoptions" 
															:key="index"
															:label="item.label"
															:value="item.value">
															</el-option>
														</el-select>
													</el-form-item>
												</el-form>            
										</div> 
									<el-row  class="button_css">
										<!-- // 2023/03/27  #14161  START -->
										<el-button @click="onSubmit('form')" type="primary" plain :disabled="Buttonpressed == 1">登録</el-button>
										<!-- // 2023/03/27  #14161  END -->
										<el-button  type="info" plain class="buttonReturn1008" @click="gotoback()">戻る</el-button>
									</el-row>
									</div>
								</el-container>
							</template>
              <!--SID1038 Body Part End-->
						</pane>
						<pane class="SideBarRight">
							<SideBar class="SidePane" />
						</pane>
					</splitpanes>
				</el-container>
			</div>
			<el-container class="footer-div">
				<el-footer class="footer-element">
					<FooterComponent />
				</el-footer>
			</el-container>
			
		</el-container>
		<el-dialog class="SID1008_DilaogDiv" title="" :visible.sync="dialogTableVisible" close="false" :close-on-click-modal="false">
				<el-container >
					<div class="SID1008__DialogPopup">
						
							<div class="button_DialogClose">
								<el-button  type="info" plain  @click="dialogTableVisible = false" >プレビューを閉じる</el-button>
							</div>	
							<el-divider class="dialogBottomHeader"></el-divider>
							<div class="RestrictUrl" v-if="getFileExtension == 'html'" v-html="gettitle_modal"></div>	
							<div v-else class="RestrictUrl"><pre>{{gettitle_modal}}</pre></div>
					</div>
				</el-container>
		</el-dialog>
	</div>
</template>

<script>

import Header from "../common/header.vue";
import SideBar from "../common/side-bar.vue";
import FooterComponent from "../common/footerComponent.vue";
import { mapGetters } from "vuex";
import router from '../../router';
import jsonConst from '../../common/CommonConst.json'
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
export default {
	name: "app",
	components: {
		Header,
		SideBar,
		FooterComponent,
		Splitpanes,
		Pane
	},
	data() {
		
		var checkradio = (rules, value, callback) => {
	
	
        var radioid= this.form.radio;
        if (radioid == 1) {
			
			if(this.form.emailoptvalue == '' ){
				callback(new Error('登録済メールアドレスから選択'));
			}else{
				this.$refs.form.clearValidate('emailoptvalue');
				callback();
			}
            
		}
		else{
			callback();
		}
		
			
         } ;
        var checkradioEmail = (rules, value, callback) => {
		var sympattern= /^[a-zA-Z0-9@.\-_+]+$/;
		var regex = /[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B/g;
		var emailFormat= /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		var chksym= this.form.emailvalue;
		var radioid= this.form.radio;
		if(radioid == 2){
				
				if(this.form.emailvalue == ''){
					
				callback(new Error('メールアドレスを入力してください。'));
				
				}else if(regex.test(chksym)){
					callback(new Error("メールアドレスは半角英数字を入力してください。"));
				}else if (!chksym.match(sympattern)) {
					callback(new Error('メールアドレスに使用できない文字が含まれています。'));
				}else if(!chksym.match(emailFormat)){
					callback(new Error('メールアドレスを正しく入力してください。'));
				}
				else{	
									
					callback();
				}
				
			}
			else{
				callback();
			}
			
		};
    return {
		// 2023/03/27  #14161  START
		Buttonpressed: 0,
		// 2023/03/27  #14161  END
		form: {
			emailoptvalue:'',
			emailvalue:'',
			templatevalue: '',
			mediumvalue: '',
			radio: '1',
			getthemevalue:'',
			getattachmentvalue:'',
			getsubjectvalue:'',
		},
		mediumvaluedisable:'0',
		getthemevaluedisable:'0',
		subjectAlert:'',
		attachalert:'',
		emailAlert:'',
		emailAlertSelect:'',
		templateSpan:'',
		themeSpan:'',
		disabled:'0',
		disable:'0',
		mediaWeb:'0',
		data_section: '',
		select_media_value: '',
		select_subject_value: '',
		select_subject_id: '',
		select_attachment_id: '',
		select_attachment_value: '',
		select_option_keyvalue: '',
		select_option_keyid: '',
		select_mail_address_id: '',
		select_mail_address_value: '',
		select_templateFile_id: '',
		// 2022/09/28 No16.メール配信先設定のテーマを変更できるようにしたい  START
		old_data_kbn: '',
		old_theme_id: '',
		// 2022/09/28 No16.メール配信先設定のテーマを変更できるようにしたい  END
		subject_type:'',
		mail_kbn: '',
		mediaNameSet:'',
		DataSection:[],
		radioMailaddress:'',
		value4: false,
		dialogTableVisible: false,
		mediaWeb_medium: 1,
		rules: {
			mediumvalue: [
			{ required: true, message: '媒体を選択してください。', trigger: 'change'},
			],
			getthemevalue: [
			{ required: true, message: 'テーマ等を選択してください。'},
			],
			radio: [
			{ required: true, message: 'メールアドレス入力方式を選択してください。'},
			],
			emailoptvalue: [
				{ validator: checkradio , trigger: 'change'},

			],
			emailvalue: [
				{ validator: checkradioEmail  },
				{max: 256, message: 'メールアドレスは256文字以下で入力してください。'}
			],

		templatevalue: [
		{ required: true, message: 'テンプレートファイルを選択してください。', trigger: 'change'},
		],
		getsubjectvalue: [
		{ required: true, message: '件名を選択してください。', trigger: 'change'},
		],
		getattachmentvalue: [
		{ required: true, message: '添付形式を選択してください。', trigger: 'change'},
		],
		},
		contract_id:''
		}
	},
	computed: {
		...mapGetters("situation1008", [
			"getdialogTableVisible",
			"getemailvalue",
			"getradio",
			"getcheck",
			"getoptionsmedium",
			"getmediumvalue",
			"getthemevalue",
			"getsubjectvalue",
			"gettemplateoptions",
			"gettemplatevalue",
			"getemailoptions",
			"getemailoptvalue",
			"getattachmentoptions",
			"getattachmentvalue",
			"getthemeoptions",
			"getsubjectoptions",
			"getmodalpopup1",
			"getmodalpopup2",
			"getStatus",
			"getdropdown_mail",
			"gettitle_modal",
			"getmessageSet",
			"getmessagecode",
			"getDrop",
			"getFileExtension",
			"getCheckTitle"

			
		]),
		...mapGetters("situation0001", [
			"getContractId",
			"getUserAuthority",
			"getServiceLinkageInfo",
			"getNews_Article_Flag",
			"getMagazine_Article_Flag",
			"getWeb_News_Article_Flag"
		])
	},
     methods: {
		onSubmit(formName) {
			this.$LogButtonEvent("1008","Register");
			this.$LogMethodIN("1008","onSubmit");
			this.themeSpan = "";
			this.templateSpan = "";
			var mail_address;

			if(this.form.radio == 1)
			{
				mail_address =  this.select_mail_address_value;
			}
			else
			{
				mail_address =  this.form.emailvalue;
			}

			this.$refs[formName].validate((valid) => {
			if (valid) {
				// 2023/03/27  #14161  START
                this.Buttonpressed= 1;
                // 2023/03/27  #14161  END
				var contract_id = this.contract_id;
				var themeid = this.select_option_keyid.toString();
				var mail_address_id = this.select_mail_address_id;
				var theme = this.select_option_keyvalue;
				var theme_split = theme.split(": ");
				// 2022/09/29 No14.テーマ等IDの画面表示  START
				//var theme_value = theme_split[0];
				var theme_value = (theme_split[0] + "  ").substring(0, 2);
				// 2022/09/29 No14.テーマ等IDの画面表示  END
				var data_kbn;
				if(theme_value == "TM"){
					data_kbn = 1;
				}else if(theme_value == "TG"){
					data_kbn = 2;
				}else{
					data_kbn = 3;
				}
				// 2022/09/28 No16.メール配信先設定のテーマを変更できるようにしたい  START
				// if(this.mediumvaluedisable == 1){
				// 	data_kbn=this.$route.params.data_kbn;
				// }
				if (theme == "") {
					// テーマが変更されない場合、変更前のデータ区分を設定する
					data_kbn = this.old_data_kbn;
				}
				// 2022/09/28 No16.メール配信先設定のテーマを変更できるようにしたい  END
				var template_file_id =  this.select_templateFile_id,
					subject_type = this.select_subject_id,
					attach_type = this.select_attachment_id,
					zero_article_email = this.value4,
					mail_kbn = this.mail_kbn;

				var addArticles = {};
				// Edit functionality
				if(this.$route.params.response)
				{
					if(this.select_media_value == "WEB"){
						addArticles = {
							// 2022/09/28 No16.メール配信先設定のテーマを変更できるようにしたい  START
							old_data_kbn: this.old_data_kbn,
							old_theme_id: this.old_theme_id,
							// 2022/09/28 No16.メール配信先設定のテーマを変更できるようにしたい  END
							contract_id: contract_id,
							data_section: 3,
							theme_id: themeid,
							data_kbn: data_kbn,
							process_kbn: 2,
							mail_address: mail_address,
							mail_address_id:mail_address_id,
							template_file_id:'999999999',
							subject_type:1,
							attach_type: 1,
							zero_article_email: this.value4
						}
					}
					else if(this.select_media_value == "雑誌/WEB")
					{
						addArticles = {
							// 2022/09/28 No16.メール配信先設定のテーマを変更できるようにしたい  START
							old_data_kbn: this.old_data_kbn,
							old_theme_id: this.old_theme_id,
							// 2022/09/28 No16.メール配信先設定のテーマを変更できるようにしたい  END
							contract_id: contract_id,
							data_section: 5,
							theme_id: themeid,
							data_kbn: data_kbn,
							process_kbn: 2,
							mail_address: mail_address,
							mail_address_id:mail_address_id,
							template_file_id:'999999999',
							subject_type:1,
							attach_type: 1,
							zero_article_email: this.value4
						}
					}
					else
					{
						addArticles = {
							// 2022/09/28 No16.メール配信先設定のテーマを変更できるようにしたい  START
							old_data_kbn: this.old_data_kbn,
							old_theme_id: this.old_theme_id,
							// 2022/09/28 No16.メール配信先設定のテーマを変更できるようにしたい  END
							contract_id: contract_id,
							data_section: 101,
							theme_id: themeid,
							data_kbn: data_kbn,
							process_kbn: 2,
							mail_address: mail_address,
							mail_address_id:mail_address_id,
							template_file_id: this.form.templatevalue,
							subject_type:subject_type,
							attach_type: attach_type,
							zero_article_email: zero_article_email,
							mail_kbn: mail_kbn
						}
					}
				}
				// Add functionality
				else{
					if(this.select_media_value == "WEB"){
							addArticles = {
							// 2022/09/28 No16.メール配信先設定のテーマを変更できるようにしたい  START
							old_data_kbn: this.old_data_kbn,
							old_theme_id: this.old_theme_id,
							// 2022/09/28 No16.メール配信先設定のテーマを変更できるようにしたい  END
							contract_id: contract_id,
							data_section: 3,
							theme_id: themeid,
							data_kbn: data_kbn,
							process_kbn: 1,
							mail_address:mail_address,
							template_file_id:'999999999',
							subject_type:1,
							attach_type: 1,
							zero_article_email: this.value4
						}
						
						
					}
					else if(this.select_media_value == "雑誌/WEB"){
							addArticles = {
							// 2022/09/28 No16.メール配信先設定のテーマを変更できるようにしたい  START
							old_data_kbn: this.old_data_kbn,
							old_theme_id: this.old_theme_id,
							// 2022/09/28 No16.メール配信先設定のテーマを変更できるようにしたい  END
							contract_id: contract_id,
							data_section: 5,
							theme_id: themeid,
							data_kbn: data_kbn,
							process_kbn: 1,
							mail_address:mail_address,
							template_file_id:'999999999',
							subject_type:1,
							attach_type: 1,
							zero_article_email: this.value4
						}
						
						
					}
					else
					{
						// 	For validating the fields 
						if(this.form.templatevalue == ""){
							this.templateSpan="テンプレートファイルを選択してください";
							return false;
						}else{
							this.templateSpan=""
						}
						if(this.form.getsubjectvalue==""){
							this.subjectAlert="件名を選択してください。";
							return false;
						}else{
							this.subjectAlert="";
						}
						if(this.form.getattachmentvalue == ""){
							this.attachalert="添付形式を選択してください。";
							return false;
						}else{
							this.attachalert=""
						}
						
							addArticles = {
							// 2022/09/28 No16.メール配信先設定のテーマを変更できるようにしたい  START
							old_data_kbn: this.old_data_kbn,
							old_theme_id: this.old_theme_id,
							// 2022/09/28 No16.メール配信先設定のテーマを変更できるようにしたい  END
							contract_id: contract_id,
							data_section: 101,
							theme_id: themeid,
							data_kbn: data_kbn,
							process_kbn: 1,
							mail_address: mail_address,						
							template_file_id: template_file_id,
							subject_type:subject_type,
							attach_type: attach_type,
							zero_article_email: zero_article_email,
							mail_kbn: mail_kbn
						}
						
											
					}
				}
				this.$store.dispatch('communication1008/addArticles',addArticles).then(() => {
					var MsgTitle;
					if(this.getCheckTitle == "1"){
						MsgTitle="登録";
					}else{
						MsgTitle="更新 ";
					}
					if(this.getStatus == "0" || this.getStatus == 0){
						// 2023/03/27  #14161  START
						this.Buttonpressed= 0;
						// 2023/03/27  #14161  END
						this.$alert(this.getmessageSet,MsgTitle, {
							confirmButtonText: 'OK',
						}).then(()=>{
							router.push("/1007")
						});
					}else{
						this.$alert(this.getmessageSet,MsgTitle, { 
							confirmButtonText: 'OK',
						}).then(()=>{
							//router.push("/1007")
						});
						// 2023/03/27  #14161  START
						this.Buttonpressed= 0;
						// 2023/03/27  #14161  END
					}
				});
			}
			});
			this.$LogMethodOut("1008","onSubmit");
		},
		mediaChange($event){
			this.$LogButtonEvent("1008","SelectMedia");
			this.$LogMethodIN("1008","mediaChange");
			for(var j=0; j<this.getDrop.length;j++){
					if($event == this.getDrop[j].value){
						this.select_media_value = this.getDrop[j]["label"];
					}
			}
			if(this.select_media_value == "WEB"){
				
				this.mediaWeb = '1';
				this.mediaWeb_medium = 0;
				/*** Change by SJ for backlog Id: 1616 */
				// For clearing the validation fields in Web Medium
				this.$refs["form"].clearValidate('getattachmentvalue');
				this.$refs["form"].clearValidate('getsubjectvalue');
				this.$refs["form"].clearValidate('templatevalue');
			}else if(this.select_media_value == "雑誌/WEB"){
				
				this.mediaWeb = '1';
				this.mediaWeb_medium = 0;
				/*** Change by SJ for backlog Id: 1616 */
				// For clearing the validation fields in Web Medium
				this.$refs["form"].clearValidate('getattachmentvalue');
				this.$refs["form"].clearValidate('getsubjectvalue');
				this.$refs["form"].clearValidate('templatevalue');
			}else{
				this.mediaWeb = '0';
				this.mediaWeb_medium = 1;
			}
			this.$LogMethodOut("1008","mediaChange");
		},
		handleChange($event){
			this.$LogButtonEvent("1008","SelectTheme");
			this.$LogMethodIN("1008","handleChange");

			
			
			this.themeSpan="";
			for(var i=0; i<this.getthemeoptions.length;i++){
				// 2022/07/20 #13212 START
				//if($event == this.getthemeoptions[i].value){
				//	this.select_option_keyid = this.getthemeoptions[i]["id"];
				//	this.select_option_keyvalue = this.getthemeoptions[i]["value"];
				if($event == this.getthemeoptions[i].id){
					var themeid = this.getthemeoptions[i]["id"];
					this.select_option_keyid = themeid.split(": ")[1];
					this.select_option_keyvalue = this.getthemeoptions[i]["value"];
				// 2022/07/20 #13212 END
				}
			}
			this.$LogMethodOut("1008","handleChange");
		},
		mailChange($event){
			this.$LogButtonEvent("1008","SelectMail");
			this.$LogMethodIN("1008","mailChange");
			this.select_mail_address_value = $event;
			this.$LogMethodOut("1008","mailChange");
		},
		templateFileChange($event){
			this.$LogButtonEvent("1008","Template");
			this.$LogMethodIN("1008","templateFileChange");
			this.templateSpan="";
			this.form.templatevalue = $event;
			for(var i=0; i<this.getdropdown_mail.length;i++)
			{
				if($event == this.getdropdown_mail[i].value){
               this.select_templateFile_id = this.getdropdown_mail[i]["value"];
				}
		}
			this.$LogMethodOut("1008","templateFileChange");
		},
		subjectChange($event){
			this.$LogButtonEvent("1008","Subject");
			this.$LogMethodIN("1008","subjectChange");
			for(var i=0; i<this.getsubjectoptions.length;i++)
			{
				if($event == this.getsubjectoptions[i].value){
               this.select_subject_id = this.getsubjectoptions[i]["id"];
               this.select_subject_value = this.getsubjectoptions[i]["value"];
				}
			}
			this.$LogMethodOut("1008","subjectChange");
		},
		attachmentChange($event){
			this.$LogButtonEvent("1008","Attachment");
			this.$LogMethodIN("1008","attachmentChange");
			for(var i=0; i<this.getattachmentoptions.length;i++)
			{
				if($event == this.getattachmentoptions[i].value){
               this.select_attachment_id = this.getattachmentoptions[i]["id"];
               this.select_attachment_value = this.getattachmentoptions[i]["value"];
				}
		}
			this.$LogMethodOut("1008","attachmentChange");
		},
		gotoback(){
			this.$LogButtonEvent("1008","Return");
			this.$LogMethodIN("1008","gotoback");
			jsonConst["redirect_path"] = '1007';
			router.push({name:"1007"});
			this.$LogMethodOut("1008","gotoback");
		},
		validationFields() {
			this.$LogButtonEvent("1008","Preview");
			this.$LogMethodIN("1008","validationFields");
			
			this.$refs['form'].clearValidate();
			if(this.form.getthemevalue == "" && this.form.templatevalue == ""){
				
				this.themeSpan="テーマを選択してください。";
				this.templateSpan="プレビュー対象を選択してください。";
			}else if(this.form.getthemevalue == "" && this.form.templatevalue){
				this.themeSpan="テーマを選択してください。";
			}else if(this.form.templatevalue == "" && this.form.getthemevalue){
				this.templateSpan="プレビュー対象を選択してください。";
			}else if(this.form.getthemevalue  && this.form.templatevalue){
				this.themeSpan="";
				this.templateSpan="";
				var theme_class= this.form.getthemevalue;
				var theme_split_class = theme_class.split(":");
				var theme_value_class = theme_split_class[0];
				var temp_id=this.form.templatevalue;
				var popup_params={
					template_file_id:temp_id,
					theme_class:theme_value_class
					
				}
            this.$store.dispatch('communication1008/AID00095_Model',popup_params) 
				
			this.dialogTableVisible = true;
 
			
			}
			this.$LogMethodOut("1008","validationFields");
		},
		changeradio() {
			this.$LogButtonEvent("1008","Radio");
			this.$LogMethodIN("1008","changeradio");
			var radioid= this.form.radio;
			if (radioid == 1) {
				this.disabled='1';
				this.disable='0';
				this.mail_kbn = 1;
				this.form.emailvalue="";
				this.$refs.form.clearValidate('emailvalue');

			}else{
				this.disabled='0';
				this.disable='1';
				this.mail_kbn = 2;
				this.form.emailoptvalue="";
				this.$refs.form.clearValidate('emailoptvalue');
			}
			this.$LogMethodOut("1008","changeradio");
		},
		getMediaDropdownInitial(){
		
			this.$LogMethodIN("1008","getMediaDropdownInitial");
			if(this.$route.params.response == undefined || this.$route.params.response == ""){
				var arrayDatasection=[];

				//For the media dropdown
				var newsSession=this.getNews_Article_Flag;
				var magazineSession=this.getMagazine_Article_Flag;
				var webSession=this.getWeb_News_Article_Flag;

				if(newsSession == true)
				{
					var innerLoopServicenews = {};
					innerLoopServicenews.label="新聞";
					innerLoopServicenews.value="1";
					arrayDatasection.push(innerLoopServicenews);
				}
				if(magazineSession == true)
				{
					var innerLoopServiceMagazine = {};
					innerLoopServiceMagazine.label="雑誌/WEB";
					innerLoopServiceMagazine.value="5";
					arrayDatasection.push(innerLoopServiceMagazine);
				} 
				if(webSession == true)
				{
					var innerLoopServiceWeb = {};
					innerLoopServiceWeb.label="WEB";
					innerLoopServiceWeb.value="2";
					arrayDatasection.push(innerLoopServiceWeb);
				} 

				this.$store.commit("situation1008/setDropdown",arrayDatasection)
			}
			this.$LogMethodOut("1008","getMediaDropdownInitial");
		}
		
	},
	watch:{
		'themeSpan': function(val){
			this.themeSpan = val;
		},
		'templateSpan' : function(val){
			this.templateSpan = val;
		}
	},
	mounted() {
		// 2022/09/28 No16.メール配信先設定のテーマを変更できるようにしたい  START
		this.old_data_kbn = this.$route.params.data_kbn;
		this.old_theme_id = this.$route.params.theme_id ? "" + this.$route.params.theme_id : "";
		// 2022/09/28 No16.メール配信先設定のテーマを変更できるようにしたい  END

		this.getMediaDropdownInitial();
        this.contract_id = this.getContractId
		jsonConst["redirect_path"] = '1007';
		var userAuthority = this.getUserAuthority
		var parameters = {
			contract_id : this.contract_id,
			user_authority:userAuthority
		};
		var parameterstheme = {
			user_authority:userAuthority
		};	
        this.$store.dispatch('communication1008/showAddress',parameters);
        this.$store.dispatch('communication1008/showThemeList',parameterstheme);
        this.$store.dispatch('communication1008/AID0031_Mail_template');
        if(this.$route.params.response)
        {
            
        for(var i=0;i<this.$route.params.response.length;i++){
            if(this.$route.params.row.media_name == 101){
                this.mediaNameSet='新聞'
            }else if(this.$route.params.row.media_name == 5){
                this.mediaNameSet='雑誌/WEB'
            }else if(this.$route.params.row.media_name == 3){
                this.mediaNameSet='WEB'
            }
            this.mediumvaluedisable = '1';
            this.getthemevaluedisable = '1';
            var data_section = this.$route.params.data_section;
			this.data_section = data_section;
			
			var data_kbn_For_edit=this.$route.params.data_kbn;
			var data_kbn_edit;
				if(data_kbn_For_edit == 1){
					data_kbn_edit = "TM";
				}else if(data_kbn_For_edit == 2){
					data_kbn_edit = "TG";
				}else{
					data_kbn_edit = "TP";
				}
				
			this.select_option_keyid = this.$route.params.theme_id;
            this.select_mail_address_value = this.$route.params.response[i].mail_address;
            this.select_mail_address_id = this.$route.params.mail_address_id;
            
            this.select_subject_id = this.$route.params.response[i].subject_type;
            if(data_section == "WEB"){
                this.select_media_value = "WEB"
                this.form.mediumvalue = "WEB";
				this.mediaWeb = 1;
				this.mediaWeb_medium = 0;

            }else if (data_section == "雑誌/WEB")
            {
                this.select_media_value = "雑誌/WEB"
                this.form.mediumvalue = "雑誌/WEB";
				this.mediaWeb = 1;
				this.mediaWeb_medium = 0;
				
            }
            else
            {
                this.select_media_value = "新聞"
                this.form.mediumvalue = "新聞";
				this.mediaWeb = 0;
				this.mediaWeb_medium = 1;
				
            }

            this.form.radio = '1';
            this.disabled = 1;
            

            this.form.emailoptvalue=this.$route.params.row.mail_address;
            // 2022/09/29 No14.テーマ等IDの画面表示  START
            //this.form.getthemevalue=data_kbn_edit + ":"+this.$route.params.row.theme_name;
            this.form.getthemevalue = data_kbn_edit + ": " + this.$route.params.row.theme_id;
            // 2022/09/29 No14.テーマ等IDの画面表示  END
            
            //To set the zero article email(switch)
            
            if(this.$route.params.row.mail_address_id == this.$route.params.response[i].mail_address_id){
                
				//To set the template value to dropdown
				// For empty the templatevalue while TM and WEB for editing
				if(this.$route.params.row.media_name == 3||this.$route.params.row.media_name == 5){
					this.form.templatevalue="";

				}else{
					this.form.templatevalue=this.$route.params.row.template_file_id;
				}
                
                
                this.value4=this.$route.params.response[i].zero_article_email;

                //To set the subject type
                var subject=this.$route.params.response[i].subject_type;
                var subject_id='';
                var subject_array=[];
                for(var k=0;k<this.getsubjectoptions.length;k++){
                    subject_array.push(this.getsubjectoptions[k].id);
                }
                var indexOf_sub=subject_array.indexOf(subject);
                subject_id=this.getsubjectoptions[indexOf_sub].value;
                this.form.getsubjectvalue=subject_id;
                //To set the attach_type
                var attach=this.$route.params.response[i].attach_type;
                var attach_type_id='';
                var attach_type_array=[];
                for(var m=0;m<this.getattachmentoptions.length;m++){
                    attach_type_array.push(this.getattachmentoptions[m].id);
                    if(this.getattachmentoptions[m].value == attach ){
                        attach_type_id = this.getattachmentoptions[m].id;
                    }
                }
                
                var indexOf_attach=attach_type_array.indexOf(attach);
                attach_type_id=this.getattachmentoptions[indexOf_attach].value;
                var attach_type_value = this.getattachmentoptions[indexOf_attach].id;
                this.form.getattachmentvalue=attach_type_id;
                this.select_attachment_id = attach_type_value;
            }
            

        }
        }else{
            //to disable the textbox default
            this.changeradio();
            
        }


  },
  beforeCreate(){
     //For the screen Title
     document.title = "メール配信先登録画面";
	},
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "1008.css";
</style>